import {connect} from 'react-redux';
import AlertDialog from '../components/AlertDialog.jsx';

import {reinvite} from '../actions/reinvite';

const mapStateToProps = state => {
  return Object.assign({}, state.alerts.dialog, Object.assign({}, {
    obfuscatedData: state.reinvite.obfuscatedData,
    isReinviting: state.reinvite.isReinviting
  }));
};

const mapDispatchToProps = dispatch => ({
  onRequestClose() {
    return dispatch({type: 'ALERT_DIALOG_CLOSE'});
  },
  reinvite(inviteId) {
    return dispatch(reinvite(inviteId));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);
